import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import WechatSliderGate from '@/components/WechatSliderGate.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'App2',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const requiresSliderGate = computed(() => route.meta.wechatSliderGate === true);
const skipCurrentGate = ref(false);
const isSliderGateEnabled = computed(
  () => requiresSliderGate.value && !skipCurrentGate.value,
);
const isGateDecisionReady = ref(false);
const isPageMounted = ref(false);
const gateKey = ref(0);
let historyTargetPath = '';
let removeHistoryListener: (() => void) | undefined;

function mountPage(): void {
  isPageMounted.value = true;
}

function applyRouteGate(): void {
  debugger
  skipCurrentGate.value = false;
  gateKey.value += 1;
  isPageMounted.value = !requiresSliderGate.value;
}

watch(() => route.fullPath, (fullPath) => {
  debugger
  if (!isGateDecisionReady.value) {
    return;
  }

  if (historyTargetPath === fullPath) {
    historyTargetPath = '';
    skipCurrentGate.value = true;
    gateKey.value += 1;
    isPageMounted.value = true;
    return;
  }

  applyRouteGate();
});

onMounted(async () => {

  // 仅 Vue Router 标记为 pop 的历史导航跳过滑块。
  removeHistoryListener = router.options.history.listen((to, _from, info) => {
    debugger
    if (info.type === 'pop') {
      historyTargetPath = to;
    }
  });

  // 首屏导航完成后再读取 meta，避免路由尚未解析时提前挂载业务页。
  await router.isReady();
  isGateDecisionReady.value = true;
  applyRouteGate();
});

onBeforeUnmount(() => {
  removeHistoryListener?.();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isPageMounted.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true),
    (isGateDecisionReady.value)
      ? (_openBlock(), _createBlock(WechatSliderGate, {
          key: gateKey.value,
          enabled: isSliderGateEnabled.value,
          onVerified: mountPage
        }, null, 8, ["enabled"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})